




















import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';

import LazyImage from '~/components/ui/lazyImage.vue';
import SwiperR from '~/components/ui/swiper-r/swiper-r.vue';
import { ISlidePosition } from '~/components/ui/swiper-r/types/ISwiper';

import ISlide from '../../ui/types/ISlide';

export default defineComponent({
  components: { SwiperR, LazyImage },
  props: {
    slides: {
      type: Array as PropType<ISlide[]>,
      default: () => [],
    },
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setup(props, { emit }) {
    const arrowEnabled = ref({
      left: false,
      right: true,
    });

    const slideChange = (slidePosition: ISlidePosition) => {
      arrowEnabled.value.left = !slidePosition.isStart;
      arrowEnabled.value.right = !slidePosition.isEnd;
    };

    return {
      arrowEnabled,
      slideChange,
    };
  },
});
